<h2 class="text-2xl font-bold mb-2 text-grey-0">Relaterade kategorier</h2>
<div [innerHTML]="businessClassificationsString()"></div>
